document.addEventListener('DOMContentLoaded', () => {
  const departingFilter = document.querySelector('.js-departing-filter');
  const selectedFilterText = document.querySelector('.selected-filter-text');
  const packageCards = document.querySelectorAll('.packages-card');
  const availableDepartingLocations = [];
  let sortedList = [];

  if (departingFilter) {
    packageCards.forEach((packageCard) => {
      availableDepartingLocations.push(packageCard.dataset.departingLocation);

      // Build list of unique locations, no duplicates
      sortedList = [...new Set(availableDepartingLocations)].sort();
    });

    sortedList.forEach((listItem) => {
      const optionName = listItem;
      const filterOption = `<div
                            class="filter-option"
                            data-filter-location="${optionName}"
                          >${optionName}</div>`;

      departingFilter.insertAdjacentHTML('beforeend', filterOption);
    });

    const filterOptions = document.querySelectorAll('.filter-option');
    filterOptions.forEach((filterOption) => {
      // On click show relevant options
      filterOption.addEventListener('click', (e) => {
        packageCards.forEach((packageCard) => {
          if (
            e.currentTarget.dataset.filterLocation ===
            packageCard.dataset.departingLocation
          ) {
            packageCard.style.display = 'flex';
          } else {
            packageCard.style.display = 'none';
          }
        });

        // Set the displayed filter text to the clicked option
        selectedFilterText.innerText = e.currentTarget.dataset.filterLocation;

        // close the filter after making selection
        departingFilter.style.display = 'none';
      });
    });

    document.querySelector('.selected-filter').addEventListener('click', () => {
      // toggle hide/show of dropdown filter
      if (departingFilter.style.display !== 'block') {
        departingFilter.style.display = 'block';
      } else {
        departingFilter.style.display = 'none';
      }
    });
  }
});
